import { Grid } from '@mui/material';
import React from 'react';
import CountEditor from '../Count/CountEditor';

const Finances = () => {
	return (
		<Grid container spacing={3}>
			<Grid size={{ xs: 6 }}>
				<CountEditor title='Rechnungen' configDataKey='Bill' />
			</Grid>
			<Grid size={{ xs: 6 }}>
				<CountEditor
					title='Profil Rechnungen'
					configDataKey='ProfileBill'
				/>
			</Grid>
		</Grid>
	);
};

export default Finances;
